//@mui
import { Stack } from '@mui/system';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
//components
import { FormHeader1, HeaderPage3 } from 'theme/elements/Headers';
import { Box } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { invalidFields } from 'components/FormCreator/types';
import BankAccountsDetails from '../../../shared/components/BankAccountsDetails';
import { FormCard } from 'theme/elements/Forms';
//constants
import { balanceTransStepsPrefix } from 'constants/balance.constants';
import { getAltshulerAccounts, getExistingBankAccounts } from 'state/reducers/bank-account.reducers';
import { getCompanyBankAccount, getSuggestedAccountId } from 'state/reducers/balance.reducers';
import _ from 'lodash';

export default function TransferDetailsForm(props: { invalidFields: invalidFields; handleBankListPick: any }) {
  const t = useAppSelector(selectTranslations);
  const altshulerAccounts = useAppSelector(getAltshulerAccounts);
  const suggestedAccountId = useAppSelector(getSuggestedAccountId);
  const existBankAccounts = useAppSelector(getExistingBankAccounts);
  const companyBankAccountId = useAppSelector(getCompanyBankAccount);
  //const suggestedAccount = altshulerAccounts.find((account: any) => account.id === suggestedAccountId);

  const suggestedAccount = useMemo(() => {
    const selectedAccount = existBankAccounts.find((account: any) => account.id === companyBankAccountId);
    let suggested = altshulerAccounts.find((account: any) => account.bankId === _.get(selectedAccount, 'bankId'));
    if (!suggested) {
      suggested = altshulerAccounts.find((account: any) => account.id === suggestedAccountId);
    }
    return suggested
  }, [altshulerAccounts, suggestedAccountId, existBankAccounts, companyBankAccountId]);

  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(_.get(suggestedAccount, 'id'));

  const otherAccounts = useMemo(() => {
    return altshulerAccounts.filter((account) => account.id !== _.get(suggestedAccount, 'id'));
  }, [suggestedAccount]);

  const handleBankAccountPick = (id: number) => {
    if (altshulerAccounts.find((account) => account.id === id)) {
      setSelectedAccountId(id);
      props.handleBankListPick(id);
    }
  };

  useEffect(() => {
    props.handleBankListPick(_.get(suggestedAccount, 'id'));
  }, [suggestedAccount]);

  return (
    <Box component="form" noValidate sx={{ marginTop: '32px' }}>
      <FormCard>
        <Stack spacing={4}>
          <FormHeader1
            title={t(`${balanceTransStepsPrefix}.3.transfer_details.header.title`)}
            text={t(`${balanceTransStepsPrefix}.3.transfer_details.header.text`)}
          />
          <Stack spacing={4}>
            {suggestedAccount && (
              <Stack spacing={1}>
                <HeaderPage3
                  title={t(`${balanceTransStepsPrefix}.3.transfer_details.suggested_account.title`)}
                />
                <BankAccountsDetails
                  accounts={[suggestedAccount]}
                  selectedAccountId={selectedAccountId}
                  handleBankPick={handleBankAccountPick}
                />
              </Stack>
            )}
            <Stack spacing={1}>
              <HeaderPage3
                title={
                  suggestedAccount
                    ? t(`${balanceTransStepsPrefix}.3.transfer_details.additional_accounts.title`)
                    : t(`${balanceTransStepsPrefix}.3.transfer_details.suggested_account.title`)
                }
              />
              {/* //TODO: should the list include the suggested? */}
              <BankAccountsDetails
                accounts={otherAccounts}
                selectedAccountId={selectedAccountId}
                handleBankPick={handleBankAccountPick}
              />
            </Stack>
            {/* <FormCreator
                                initialValidation={props.invalidFields}
                                name="newBankAccount"
                                handleChange={handleBankChoose}
                                // validations = {fieldsValidations}
                                fieldsGroups={[
                                {
                                    // TODO: PUT BANK CHOOSE IN VALIDATION.
                                }
                        
                        ]}
                            /> */}
          </Stack>
        </Stack>
      </FormCard>
    </Box>
  );
}
